import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTripDetails } from '../../features/admin/tripSlice';
import { AppDispatch, RootState } from '../../store';
import Loading from '../ui/Loading';
import { Link, useParams } from 'react-router-dom';
import { TiGroupOutline } from "react-icons/ti";
import { BsCardList } from "react-icons/bs";
import dayjs from "dayjs";
import 'swiper/css';
import 'swiper/css/effect-cube';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { FaBed, FaChild } from 'react-icons/fa';
import { FaArrowLeftLong, FaArrowRightLong } from 'react-icons/fa6';
import TripDetails from './TripDetails';
import TripPlace from './TripPlace';
import { formatDateRange } from '../../utils/data';
import LoginPopup from '../ui/LoginPopup';
import { useSEO } from '../../custom hooks/useSEO';


const TripLayout = () => {
    const { tripId } = useParams();
    const { t, i18n } = useTranslation();
    const { t: tSeo } = useTranslation("seo");

    const seo = useSEO({
        title: tSeo("tripDetails.title"),
        description: tSeo("tripDetails.description")
    });
    const dispatch = useDispatch<AppDispatch>();
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [activeTab, setActiveTab] = useState<'details' | 'stay'>('details')
    const { trip, loading } = useSelector((state: RootState) => state.tripSlice);
    const { user } = useSelector((state: RootState) => state.user);
    dayjs.locale(i18n.language);
    const ended = trip?.fromDate && (new Date() > new Date(trip?.fromDate));
    useEffect(() => {
        if (tripId) {
            dispatch(fetchTripDetails({ tripId: Number(tripId), userId: user?.id }));
        }
    }, [dispatch, tripId, user?.id]);
    if (loading || !trip) return <Loading />
    return (
        <div className=' bg-white'>
            {seo}
            <Swiper
                slidesPerView={1}
                pagination={{ clickable: true }}
                autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                }}
                modules={[Pagination, Autoplay]}
                className="h-[80vh]"
            >
                {trip?.tripImages?.map((image, index) => (
                    <SwiperSlide key={index}>
                        <div className="h-[80vh] bg-cover bg-center relative" style={{ backgroundImage: `url(${image.url})`, }}>
                            <div className="absolute inset-0 bg-black/30 z-10" />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className=' padding-container xs:pb-10 xs:pt-6 sm:py-10 md:pt-1'>
                <div className=' sm:flex-row xs:flex-col flex gap-5 justify-between text-white border-b border-grayColor py-5'>
                    <div className=' text-textSecond'>
                        <h1 className=' text-black text-2xl font-semibold'>{trip?.fromLocation}, {trip?.toLocation}</h1>
                        <div className='flex gap-1'>
                            <p>{t("date")}:</p>
                            <p>{formatDateRange(trip?.fromDate, trip?.toDate)}</p>
                        </div>
                        <p className=' flex gap-2 items-center'><TiGroupOutline /> {trip?.numberOfAdults} {t("people")}</p>
                        {trip?.numberOfChilds !== 0 && <p className=' flex gap-2 items-center'><FaChild /> {trip?.numberOfChilds} {t("children")}</p>}
                    </div>
                    <div>
                        <p className=' text-secondry font-semibold text-2xl'>{trip?.price} {trip.currencyCode}</p>
                        {ended ? (
                            <button
                                disabled
                                className="mt-4 w-fit rounded-md px-4 py-1 bg-gray-400 text-white font-medium cursor-not-allowed opacity-80"
                            >
                                {t("not-available")}
                            </button>
                        ) : user?.id ?
                            (<Link to={`/trips/${trip.id}/check-out`} className="mt-4 flex-center gap-2 w-full  rounded-md px-4 py-2  bg-primary">
                                {t("book-now")}
                                {i18n.language === "ar" ? <FaArrowLeftLong /> : <FaArrowRightLong />}
                            </Link>) :
                            <button onClick={() => setShowLoginModal(true)} className="mt-4 flex-center gap-2 w-full  rounded-md px-4 py-2  bg-primary">
                                {t("book-now")}
                                {i18n.language === "ar" ? <FaArrowLeftLong /> : <FaArrowRightLong />}
                            </button>
                        }

                    </div>
                </div>
                <div className="flex mt-10 bg-gray-200 p-3 w-fit gap-5 text-sm rounded-lg">
                    <button
                        onClick={() => setActiveTab('details')}
                        className={`flex-center focus:outline-none gap-2 px-4 py-2 text-black rounded-lg  font-medium transition ${activeTab === 'details'
                            ? 'bg-secondry text-white'
                            : ' '
                            }`}
                    >
                        <BsCardList className=' text-lg' />
                        {t('trip-details')}
                    </button>
                    <button
                        onClick={() => setActiveTab('stay')}
                        className={`flex-center focus:outline-none gap-2 px-4 py-2 text-black rounded-lg  font-medium transition ${activeTab === 'stay'
                            ? 'bg-secondry text-white'
                            : ' '
                            }`}
                    >
                        <FaBed className=' text-lg' />
                        {t('stay-tab')}
                    </button>

                </div>
                <div className=' mt-5'>
                    {activeTab === 'details' && <TripDetails trip={trip} />}
                    {activeTab === 'stay' && <TripPlace place={trip.place} />}
                </div>
            </div>
            {
                showLoginModal && (
                    <LoginPopup setShow={setShowLoginModal} />
                )
            }
        </div >
    )
}

export default TripLayout